<template>
  <!-- <hr class="horizontal above-md-hide" style="margin: 8px 0" /> -->
  <div
    class="apply_coupon_container"
    :class="[isOpen && 'opened_coupon_container']"
  >
    <div
      class="d-flex-row space-between cursor-pointer flex-5"
      @click="openPromo"
    >
      <div class="d-flex-row justify-start">
        <CouponIcon />
        <p class="t-white font-family-2 bold-l">
          {{ $t("cart.apply_promo_code") }}
        </p>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="plus"
        width="10"
        height="10"
        viewBox="0 0 160 160"
        fill="#fff"
        :class="[isOpen && 'minus']"
      >
        <rect class="vertical-line" x="70" width="20" height="160" />
        <rect class="horizontal-line" y="70" width="160" height="20" />
      </svg>
    </div>
    <form @submit.prevent="submit" class="d-flex-row space-between align-start">
      <div class="d-flex-row flex-7">
        <input-field
          :variant="'medium'"
          placeholder="Enter Coupon"
          v-model="code"
          :isDisabled="disableAdd"
        />
      </div>
      <button
        class="flex-3 d-flex-row b-radius-6 secondary opacity height-42 cursor-pointer medium-l font-family-1 f-w-600"
        :disabled="disableAdd"
        v-if="!disableAdd"
      >
        {{ $t("cart.apply") }}
      </button>

      <button
        @click="clearCartCoupon"
        class="flex-3 remove_coupon_btn"
        v-if="disableAdd"
      >
        <p class="t-white medium-l font-family-1">{{ $t("remove_coupon") }}</p>
      </button>
    </form>
  </div>
</template>

<script setup>
import CouponIcon from "~/components/icons/CouponIcon.vue";
import InputField from "~/components/custom/InputField.vue";
import { ref } from "vue";
const { getUserCurrency } = useUserStore();
const { getGame } = useGameStore();
const { setSnack } = useGenericStore();
const checkoutStore = useCheckoutStore();

const props = defineProps({
  totalPrice: {
    type: Number,
    default: 0,
  },
  setPrice: {
    default: () => {},
  },
  type: {
    type: String,
    default: "addCoupon",
  },
  invoiceCode: {
    type: String,
    default: "",
  },
  refetchOrder: {
    default: () => {},
  },
  checkPaymentButton: {
    default: () => {},
  },
  coupon: {
    default: null,
  },
});
const isOpen = ref(false);
const code = ref("");

const openPromo = () => {
  isOpen.value = !isOpen.value;
};

const addCoupon = async () => {
  try {
    const { data: response } = await useApiPost("/api/get-coupon-by-code", {
      method: "POST",
      body: {
        locale: getLocale(),
        currency_id: getUserCurrency,
        game_id: getGame?.id,
        code: code.value,
        amount: props.totalPrice,
      },
    });

    if (response.message_status === "ERROR") {
      setSnack({
        title: response.message_title,
        description: response.message,
        timeout: 5000,
        showProgress: true,
        type: "paymenterror",
        position: "top-right",
        isOpen: true,
      });
    }
    if (response.message_status === "SUCCESS") {
      setSnack({
        title: response.message_title,
        description: response.message,
        timeout: 5000,
        showProgress: true,
        type: "paymentsuccess",
        position: "top-right",
        isOpen: true,
      });
      const couponData = response.coupon;
      checkoutStore.setCoupon(couponData);
      isOpen.value = false;
    }

    // console.log(response);
  } catch (error) {
    console.log(error);
  }
};
const defaultCoupon = async () => {
  try {
    if (checkoutStore.getSelectedCoupon?.id) return;
    checkoutStore.setCoupon({
      code: "WELCOME5",
      description: "ONEFORALL",
      discount: 5,
      id: 10,
      title: "ONEFORALL",
      usage_type: 1,
    });
  } catch (error) {
    console.log(error);
  }
};
const applyCouponToOrder = async () => {
  try {
    const { data: response } = await useApiPost("/api/apply-coupon-to-order", {
      method: "POST",
      body: {
        locale: getLocale(),
        code: code.value,
        invoice_code: props.invoiceCode,
      },
    });
    if (response.message_status === "ERROR") {
      setSnack({
        title: response.message_title,
        description: response.message,
        timeout: 5000,
        showProgress: true,
        type: "paymenterror",
        position: "top-right",
        isOpen: true,
      });
    }
    if (response.message_status === "SUCCESS") {
      setSnack({
        title: response.message_title,
        description: response.message,
        timeout: 5000,
        showProgress: true,
        type: "paymentsuccess",
        position: "top-right",
        isOpen: true,
      });

      props.refetchOrder().then(() => {
        props.checkPaymentButton();
      });
    }
  } catch (error) {
    console.log(error);
  }
};
const submit = () => {
  if (disableAdd.value) return;
  if (props.type === "addCoupon") {
    addCoupon();
  } else if (props.type === "applyCouponToOrder") {
    applyCouponToOrder();
  }
};

const disableAdd = computed(() => {
  if (props.type === "addCoupon") {
    if (checkoutStore.getSelectedCoupon?.id) {
      return true;
    }
  }

  if (props.type === "applyCouponToOrder") {
    if (props.coupon?.id || props.coupon?.code) {
      return true;
    }
  }
  return false;
});

if (props.type === "addCoupon") {
  if (checkoutStore.fullPack?.id) {
    code.value = "WELCOME5";
    defaultCoupon();
  }
}
if (props.type === "applyCouponToOrder") {
  if (props.coupon?.code) {
    code.value = props.coupon?.code;
  }
}

const clearPayCartCoupon = async (invoiceCode) => {
  try {
    const { data } = await useApiPost("/api/remove-coupon-from-order", {
      method: "post",
      body: {
        locale: getLocale(),
        invoice_code: invoiceCode,
      },
    });
    props.refetchOrder();

    return data;
  } catch (error) {
    console.log(error);
  }
};

const clearCartCoupon = async () => {
  if (props.type === "addCoupon") {
    checkoutStore.removeCoupon();
  } else if (props.type === "applyCouponToOrder") {
    clearPayCartCoupon(props.invoiceCode);
  }
};
</script>
